import {Injectable, signal} from "@angular/core";
import {TranslateService} from "@ngx-translate/core";
import {langTypes} from "../types/lang.type";
import {LOCAL_STOAGE_KEYS} from "../const/localstorage.const";
import {Translation, translationProperty} from "../model/translation.model";
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  languages: langTypes[] = ['it', 'en'];
  currentLang = signal<langTypes>('it');

  constructor(private translateService: TranslateService) {}

  init(){

    const localLang = localStorage.getItem(LOCAL_STOAGE_KEYS.LOCAL_STORAGE_LANGUAGE);
    if (localLang && localLang != 'null') {
      //@ts-ignore
      this.language = localLang;
    } else {
      const index = _.indexOf(this.languages, this.browserLang);
      this.language = index != -1 ? this.languages[index]: 'en';
    }

    console.log("browser lang ", this.browserLang);
  }

  set language(lang: langTypes) {
    this.translateService.setDefaultLang(lang);
    localStorage.setItem(LOCAL_STOAGE_KEYS.LOCAL_STORAGE_LANGUAGE, lang);
    this.currentLang.set(lang);
  }

  get language(): string {
    return this.translateService.getDefaultLang();
  }

  get browserLang(): string {
    return this.translateService.getBrowserLang();
  }

  static getTranslation(translations: Translation[], property: translationProperty = 'name'): string {
    const localLang = localStorage.getItem(LOCAL_STOAGE_KEYS.LOCAL_STORAGE_LANGUAGE);
    const defaultLang = 'it';

    let foundTranslation = _.find(translations, item => item.languageCode == localLang);

    if (!foundTranslation) {
      foundTranslation = _.find(translations, item => item.languageCode == defaultLang);
    }

    return _.get(foundTranslation, property);
  }
}
